<template>
  <div class="min-h-screen">
    <SiteHeader :page-name="'List Manager'" />
    <div class="mt-4 w-full m-auto">
      <ListManager></ListManager>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
